module.exports = __webpack_public_path__ + "img/shop7-9.50daa2b1.png";